import { useNavigate } from '@tanstack/react-router'
import { type PropsWithChildren, useLayoutEffect } from 'react'

import { LOCAL_STORAGE_KEY_MAP } from '@/lib/constants/platform'

export const RedirectOnSignedIn = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()

  useLayoutEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEY_MAP.token)
    if (token) {
      void navigate({ to: '/' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}
